import React from "react";

/**
 * Impressum – GVSI Clean & Care
 * Required company information under German law (§ 5 TMG).
 * Adjust with your client's real details.
 */
export default function Impressum() {
  return (
    <div className="prose prose-sm sm:prose max-w-none text-gray-700">
      <h1 className="text-2xl font-bold text-gray-900">Impressum</h1>

      <h2 className="mt-6 text-xl font-semibold text-gray-900">Angaben gemäß § 5 TMG</h2>
      <p>
        GVSI Clean & Care<br />
        Geschäftsführer: Armanda Gashi (CEO)<br />
        Adresse: Hauptstraße 123,
        Rosenheim, 83024<br />
        Deutschland
      </p>


      <h2 className="mt-6 text-xl font-semibold text-gray-900">Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf
        diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis
        10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
        übermittelte oder gespeicherte fremde Informationen zu überwachen oder
        nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </p>
      <p>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen
        nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
        diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
        konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
        Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
      </p>

      <h2 className="mt-6 text-xl font-semibold text-gray-900">Haftung für Links</h2>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte
        wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte
        auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist
        stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
      </p>

      <h2 className="mt-6 text-xl font-semibold text-gray-900">Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
        des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
        Autors bzw. Erstellers.
      </p>
    </div>
  );
}
